const prodApi = {
  products: "https://www.data.banilux.ng/data/products",
  exhibits: "https://www.data.banilux.ng/data/exhibits",
  guestrooms: "https://www.data.banilux.ng/data/guestrooms",
};

export { prodApi };
